/**
 * Permit Wall clock - HH:MM:SS in Asia/Amman, Western digits always.
 *
 * The `en-GB` locale + `numberingSystem: "latn"` guarantees 0-9 glyphs
 * regardless of the kiosk's OS locale, and `timeZone: "Asia/Amman"` keeps
 * the wall clock matched to the municipality portal and the office wall
 * even if the kiosk's system timezone drifts. The formatter is built once;
 * only `Date.now()` changes each tick.
 */

import { useEffect, useMemo, useState } from "react";

export function WallClock({ className, style }: { className?: string; style?: React.CSSProperties }) {
  const fmt = useMemo(
    () =>
      new Intl.DateTimeFormat("en-GB", {
        timeZone: "Asia/Amman",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hourCycle: "h23",
        numberingSystem: "latn",
      }),
    [],
  );

  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <div dir="ltr" className={className} style={style}>
      {fmt.format(now)}
    </div>
  );
}
